import { apiClient } from '@/shared/lib/api/client';

export type RegistrarDispositivoPushPayload = {
  token: string;
  plataforma: 'ANDROID' | 'IOS' | 'WEB';
  aplicativo: 'APP_ESCOLA' | 'APP_FAMILIA' | 'WEB_ESCOLA' | 'WEB_FAMILIA';
  modelo?: string;
  versaoApp?: string;
};

export const dispositivoPushService = {
  registrar: async (payload: RegistrarDispositivoPushPayload): Promise<void> => {
    await apiClient.put('/v1/dispositivos-push', payload);
  },

  desativar: async (token: string): Promise<void> => {
    await apiClient.delete('/v1/dispositivos-push', { data: { token } });
  },
};
